import React from 'react';
import NavDropdownToggle from './nav-dropdown-toggle';
import AniLink from "gatsby-plugin-transition-link/AniLink"

interface Item {
  label: string;
  uri: string;
  menuIcons?: {
    icon: {
      altText: string;
      link: string;
      mediaItemUrl: string;
    }
  }
  childItems?: {
    nodes: Item[];
  }
}

interface LinksParams {
  items: Item[];
  experimentA?: boolean;
}

const LinksContainer = ({ items, experimentA = false }: LinksParams) => {
  const topLevelLinks = items.filter(item => item.childItems?.nodes?.length === 0);
  const dropdownLinks = items.filter(item => item.childItems && item.childItems.nodes.length > 0);

  return (
    <div className='links-container'>
      {(dropdownLinks && dropdownLinks?.length > 0 && experimentA === false) ? dropdownLinks.map((item, index) => {
        return <NavDropdownToggle key={index} label={item.label} items={item.childItems?.nodes} />
      }) : null}
      {(topLevelLinks && topLevelLinks?.length > 0 && experimentA === false) ? topLevelLinks.map((item, index) => {
        return <div className='nav-dropdown-trigger'><AniLink className='toggle' key={index} fade to={item.uri}>{item.label}</AniLink></div>
      }) : null}
    </div>
  )
}

export default LinksContainer;
